/**
 * Footer — centralized copy strings (AOF 25, i18n posture).
 */

export const footerCopy = {
  tagline: "score and stage agent ensembles",
  version: "v0.1",
  githubLabel: "GitHub",
  githubHref: "https://github.com/animachord/animachord",
  separator: "·",
} as const;
